import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'
import { getShareConfig } from './api'

Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  created() {
    getShareConfig().then(res => {
      if (res.data && res.data.title) {
        document.title = res.data.title
      }
    }).catch(() => {})
  }
}).$mount('#app')
